import React from 'react';
import { connect } from "react-redux";
import { withRouter } from '../../../shared/hoc/withRouter';
import axios from 'axios';
import PortletSpinner from '../../../partials/layout/PortletSpinner';
import DataGrid from 'devextreme-react/data-grid';

class ResumeAIChatBot extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sessionID: null,
            response: null,
            question: '',
            loading: false,
            sessions: [],
            showSessions: false,
            selectedSession: null,
        };
    }

    // Fetch past sessions
    getPastSessions = async () => {
        try {
            this.setState({ loading: true, sessions: [] });
            const token = this.props.authToken.chatbotToken;
            const { data: sessions } = await axios.get(
                'https://localhost:7238/api/Session/GetSessionsForUser',
                {
                    headers: {
                        'X-USER-TOKEN': token,
                        'Accept': '*/*',
                    },
                }
            );
            this.setState({ sessions, showSessions: true, loading: false });
        } catch (error) {
            console.error('Error fetching sessions:', error);
            this.setState({ loading: false, sessions: [] });
            // this.props.enqueueSnackbar('Failed to load past sessions', { variant: 'error' });
        }
    };

    resumeSession = async (sessionId) => {
        try {
            this.setState({ loading: true });
            const token = this.props.authToken.chatbotToken;
            const { data: responseObj } = await axios.post(
                'https://localhost:7238/api/Session/ResumeSession',
                { sessionId },
                {
                    headers: {
                        'X-USER-TOKEN': token,
                        'Accept': '*/*',
                    },
                }
            );

            const userQuestion = responseObj.find(item => item.role === 'user')?.content || '';
            const assistantResponse = responseObj.find(item => item.role === 'assistant')?.content || '';

            this.setState({
                sessionID: sessionId,
                loading: false,
            });

            this.props.onSessionResume(sessionId, userQuestion, assistantResponse);
        } catch (error) {
            console.error('Error resuming session:', error);
            this.setState({ loading: false });
        }
    };

    onSelectionChangedHandler = async (e) => {
        const selectedData = e.selectedRowsData;
        
        if (selectedData.length > 0) {
            const rowData = selectedData[0];
            const sessionId = rowData.sessionId;
            await this.resumeSession(sessionId);
        }
    };

    render() {
        const { sessions, showSessions, loading } = this.state;

        const columns = [
            { resource: "Title", dataField: "title" },
            { resource: "Days Ago", dataField: "daysAgo" }
        ];

        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%' }}>
                {/* Load Past Conversations Button */}
                <button
                    onClick={this.getPastSessions}
                    disabled={showSessions}
                    style={{
                        //marginTop: '20px',
                        padding: '10px 20px',
                        //backgroundColor: '#007bff',
                        backgroundColor: showSessions ? '#cccccc' : '#007bff',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        fontSize: '16px',
                        cursor: 'pointer',
                        cursor: showSessions ? 'not-allowed' : 'pointer',
                        transition: 'background-color 0.2s',
                    }}
                    onMouseOver={(e) => !showSessions && (e.target.style.backgroundColor = '#0056b3')}
                    onMouseOut={(e) => !showSessions && (e.target.style.backgroundColor = '#007bff')}
                >
                    Load Past Conversations
                </button>

                {/* Past Sessions List */}
                {showSessions && (
                    <div
                        style={{
                            width: '80%',
                            marginTop: '20px',
                            maxHeight: '800px',
                            overflowY: 'auto',
                            border: '1px solid #e0e0e0',
                            borderRadius: '5px',
                            backgroundColor: '#f9f9f9',
                            padding: '10px',
                        }}
                    >
                        <DataGrid
                            //ref={this.gridRef}
                            //disabled={this.state.isBusy}
                            //{...this.dataGridProps}
                            hoverStateEnabled={false}
                            rowAlternationEnabled={true}
                            dataSource={sessions}
                            columns={columns}
                            keyExpr="sessionId"
                            selection={{
                                mode: 'single',
                                selectAllMode: "allPages",
                                showCheckBoxesMode: "always"
                            }}
                            onSelectionChanged={this.onSelectionChangedHandler}
                            //onSelectionChanged={onSelectionChanged}
                        >
                        </DataGrid>
                    </div>
                )}

                {/* Spinner */}
                {loading && (
                    <div
                        style={{
                            width: '80%',
                            marginTop: '20px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <PortletSpinner />
                    </div>
                )}

                {/* <div
                    style={{
                        position: 'absolute',
                        width: '80%',
                        bottom: '5px',
                        borderRadius: '5px',
                        textAlign: 'center',
                        fontSize: '14px',
                        fontWeight: '350',
                    }}
                >
                    AI-generated content may be inaccurate.
                </div> */}
            </div>
        );
    }
}

const mapStateToProps = store => ({
    authToken: store.auth.authToken
});

export default withRouter(connect(mapStateToProps)(ResumeAIChatBot));